import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import apiUser from 'api/user';
import { setCurrentCurrency } from 'actions/home';
import ButtonsGroup from 'components/ui/buttonsGroup';
import Button from 'components/ui/button';

const DEFAULT_CURRENCY_LIST = ['GBP', 'EUR', 'USD'];

interface Props {
  filteredCurrencyList?: string[];
}

export const CurrencySelect: React.FC<Props> = ({ filteredCurrencyList }) => {
  const dispatch = useDispatch();
  const selectedCurrency = useSelector(
    (state: RootState) => state.home.currentCurrency
  );

  const saveSelectedCurrency = async (currency: string) => {
    try {
      await apiUser.setConfig({
        param: 'homePageCurrency',
        value: currency,
      });
    } catch (err) {
      dispatch(setCurrentCurrency({ currency: selectedCurrency }));
      console.error(err);
    }
  };

  const handleCurrencyChange = (state: string[]) => {
    const currency = state[0];
    saveSelectedCurrency(currency);
    dispatch(setCurrentCurrency({ currency }));
  };

  return (
    <ButtonsGroup
      mode='singleRequired'
      activeButtons={[selectedCurrency]}
      onClick={handleCurrencyChange}>
      {(filteredCurrencyList || DEFAULT_CURRENCY_LIST).map((currency) => (
        <Button id={currency} text={currency} />
      ))}
    </ButtonsGroup>
  );
};
